/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Building protection mode (způsob ochrany nemovitosti) - indicates if the building is under special protection or restriction
 */
export interface BudZpochnDto { 
    /**
     * Building identifier (BUD_ID)
     */
    budId?: number;
    /**
     * End date when this protection mode ceased (null if still active)
     */
    endDate?: string;
    /**
     * Unique identifier of the protection mode record
     */
    id?: number;
    /**
     * Start date when this protection mode became effective
     */
    startDate?: string;
    /**
     * Protection mode code (ZPOCHN_KOD) from the cadastral codelist
     */
    zpochnKod?: number;
    /**
     * Protection mode name (e.g., \'Kulturní památka\', \'Stavební uzávěra\')
     */
    zpochnNazev?: string;
}

